import { faFlag } from "@fortawesome/duotone-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  FlexBox,
  JoonColorExpanded,
  JoonUIColor,
  SPACING,
  Typography,
} from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import { DoterChatFlagContent } from "../../../../constants"
import { AIPromptFlag, GreenFlag } from "../../../../types"

export const FLAG_LABEL_KEYS = {
  [AIPromptFlag.BULLYING]: "DC_FLAG_BULLYING",
  [AIPromptFlag.ANXIETY]: "DC_FLAG_ANXIETY",
  [AIPromptFlag.DEPRESSION]: "DC_FLAG_DEPRESSION",
  [AIPromptFlag.ABUSE]: "DC_FLAG_ABUSE",
  [AIPromptFlag.SELF_HARM]: "DC_FLAG_SELF_HARM",
  [AIPromptFlag.SEXUAL_CONTENT]: "DC_FLAG_SEXUAL_CONTENT",
  [AIPromptFlag.SUBSTANCE]: "DC_FLAG_SUBSTANCE",
  [AIPromptFlag.VIOLENCE]: "DC_FLAG_VIOLENCE",
  [AIPromptFlag.PROFANITY]: "DC_FLAG_PROFANITY",
  [GreenFlag.GROWTH]: "DC_FLAG_GROWTH",
  [GreenFlag.EMPATHY_KINDNESS]: "DC_FLAG_EMPATHY_KINDNESS",
  [GreenFlag.GRIEF_LOSS]: "DC_FLAG_GRIEF_LOSS",
  [GreenFlag.FAMILY_CONNECTION]: "DC_FLAG_FAMILY_CONNECTION",
  [GreenFlag.FRIENDSHIP_BELONGING]: "DC_FLAG_FRIENDSHIP_BELONGING",
  [GreenFlag.RESILIENCE]: "DC_FLAG_RESILIENCE",
  [GreenFlag.IDENTITY_PRIDE]: "DC_FLAG_IDENTITY_PRIDE",
  [GreenFlag.DEEP_CURIOSITY]: "DC_FLAG_DEEP_CURIOSITY",
  [GreenFlag.EMOTIONAL_INSIGHT]: "DC_FLAG_EMOTIONAL_INSIGHT",
  [GreenFlag.CREATIVE_BREAKTHROUGH]: "DC_FLAG_CREATIVE_BREAKTHROUGH",
  [GreenFlag.ARTISTIC_EXPRESSION]: "DC_FLAG_ARTISTIC_EXPRESSION",
  [GreenFlag.DISCUSSION_TOPIC]: "DC_FLAG_DISCUSSION_TOPIC",
} as const

const DoterChatFlag = ({ type }: { type: AIPromptFlag | GreenFlag }) => {
  const { t } = useTranslation()
  const { icon, color } = DoterChatFlagContent[type] || {
    icon: faFlag,
    color: JoonColorExpanded.neutral400,
  }
  const labelKey = FLAG_LABEL_KEYS[type]

  if (!labelKey) return null
  const text = t(labelKey)

  return (
    <FlexBox
      style={{
        borderRadius: SPACING.space2,
        backgroundColor: color,
        padding: "4px 6px",
        width: "fit-content",
        gap: SPACING.space1,
      }}
    >
      <FontAwesomeIcon
        icon={icon}
        fontSize={15}
        color={JoonUIColor.text.inverted}
      />
      <Typography
        variant="bodyXSmall"
        style={{ fontWeight: 500 }}
        color={JoonUIColor.text.inverted}
      >
        {text}
      </Typography>
    </FlexBox>
  )
}

export default DoterChatFlag
